import { useMemo } from 'react';

import type { DemographicStat } from '../../../../entities/post/models';
import type { TableColumnConfig } from '../../../../shared/components/data-table';
import { DataTable } from '../../../../shared/components/data-table';
import { TableHeader } from './table-header';

interface Props {
  raceData: DemographicStat[];
  onRaceClick?: (race: DemographicStat, event: React.MouseEvent) => void;
  isLoading?: boolean;
}

export function RaceTable({ raceData, onRaceClick, isLoading }: Props) {
  const columns = useMemo(
    (): TableColumnConfig<DemographicStat>[] => [
      {
        key: 'name',
        header: 'Race',
        size: 'auto',
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'postCount',
        header: 'Volume',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalViews',
        header: 'Views',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalLikes',
        header: 'Likes',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalShares',
        header: 'Shares',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalComments',
        header: 'Comments',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
    ],
    [],
  );

  const handleRaceClick = (race: DemographicStat, event: React.MouseEvent) => {
    onRaceClick?.(race, event);
  };

  return (
    <DataTable
      data={raceData}
      header={<TableHeader title="Race" />}
      columns={columns}
      onRowClick={handleRaceClick}
      pageSize={10}
      minHeight="200px"
      isLoading={isLoading}
    />
  );
}
